import { render, staticRenderFns } from "./ModelExportItem.vue?vue&type=template&id=06ac8def&scoped=true"
import script from "./ModelExportItem.vue?vue&type=script&lang=js"
export * from "./ModelExportItem.vue?vue&type=script&lang=js"
import style0 from "./ModelExportItem.vue?vue&type=style&index=0&id=06ac8def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac8def",
  null
  
)

export default component.exports